import * as React from 'react';

const TopBlobSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="224"
        height="160"
        viewBox="0 0 224 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            id="Vector"
            d="M80.6259 159.152C34.5633 159.091 85.5237 128.173 45.9076 128.06C-15.1924 127.886 -29.2199 87.744 93.2737 24.1498C215.767 -39.4445 271.022 38.8981 173.538 117.131C146.276 139.009 105.316 159.18 80.6269 159.144L80.6259 159.152Z"
            fill="#ACC7CC"
        />
    </svg>
);

TopBlobSvg.displayName = 'TopBlobSvg';
export default TopBlobSvg;
